import { ChangeDetectionStrategy, Component, forwardRef } from "@angular/core";
import { InputFormWrapper } from "../wrapper.interface";
import { SliderConfig } from "./slider.config";
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { SliderModule } from "primeng/slider";
import { V_FORM_CONTROL_TOKEN, WRAPPER_TOKEN } from "../wrapper.tokens";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector:    'v-slider',
    templateUrl: './slider.component.haml',
    styleUrls:   ['./slider.component.sass', '../input.style.sass'],
    providers:   [
        { provide: V_FORM_CONTROL_TOKEN, useExisting: forwardRef(() => VSliderComponent) },
        { provide: WRAPPER_TOKEN, useExisting: forwardRef(() => VSliderComponent) },
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => VSliderComponent), multi: true }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports:         [CommonModule, SliderModule, ReactiveFormsModule, TranslateModule]
})
export class VSliderComponent extends InputFormWrapper<SliderConfig, number> {
    protected readonly _baseConfig: SliderConfig = SliderConfig.baseTheme.Default;
}